import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalVar from './utilities/globalVar'

Vue.config.productionTip = false
Vue.prototype.GlobalData = globalVar

export function createApp () {
    
    const app = new Vue({
        // el: '#app',
        router,
        store,
        render: h => h(App)
    })

    return { app, router, store }
}


